import React from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setReorderIds } from "src/store/mine_craft/bannersSlice";

import DrawerRight from "src/componets/DrawerRight";
import Tabs from "src/componets/Tabs";
import Reorder from "./_partials/_Reorder";

const Settings = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.banners.reorderIds);

  function onClose() {
    dispatch(setReorderIds({ ids: null }));
  }

  return (
    <DrawerRight
      open={!!reorderIds}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <h6 className="v-content-label">Choose Option</h6>

      <Tabs
        defaultActiveKey='tab-reorder'
        items={[
          { label: 'Reorder', key: 'tab-reorder', children: <Reorder /> },
        ]}
      />
    </DrawerRight>
  )
}

export default Settings;
